import React, { useState, useEffect, useContext } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';
import './MachineDetails.css';
import '../table-list-2.css';
import '../mobile-pagenav-dropdown.css';
import machineHolder from '../assets/picture/machineholder.jpg';
import { ReactComponent as FileIcon } from '../assets/svg/icon-file-16.svg';
import { ReactComponent as BackIcon } from '../assets/svg/icon-topmenu-back.svg';
import { ReactComponent as PdfIcon } from '../assets/svg/icon-pdf.svg';
import { ReactComponent as WordIcon } from '../assets/svg/icon-word.svg';
import { ReactComponent as ExcelIcon } from '../assets/svg/icon-excel.svg';
import { ReactComponent as ImageIcon } from '../assets/svg/icon-image.svg';
import { ReactComponent as ZipIcon } from '../assets/svg/icon-zip.svg';
import { ReactComponent as TextIcon } from '../assets/svg/icon-txt.svg';
import { ReactComponent as CadIcon } from '../assets/svg/icon-cad.svg';
import { ReactComponent as GenericFileIcon } from '../assets/svg/icon-file-16.svg'; // fallback
import { useTranslation } from 'react-i18next';
import { ApiBaseUrlContext } from '../App';


const MachineDetails = () => {
    const navigate = useNavigate();
    const { machineid } = useParams();
    const [machine, setMachine] = useState(null);
    const { t } = useTranslation();
    const [currencySymbol, setCurrencySymbol] = useState('kr');
    const [currencyPosition, setCurrencyPosition] = useState('right');
    const [activeServiceReports, setActiveServiceReports] = useState([]);
    const [closedServiceReports, setClosedServiceReports] = useState([]);
    const [selectedMachineCost, setSelectedMachineCost] = useState(null);
    const [faultErrors, setFaultErrors] = useState([]);
    const [machineMaintenances, setMachineMaintenances] = useState({
        daily: [],
        weekly: [],
        monthly: [],
        annually: [],
        upcoming: [],
        new: [],
        open: [],
        overdue: []
    });
    const [reseller, setReseller] = useState(null);
    const [externalTechs, setExternalTechs] = useState([]);
    const [totalMaintenanceCost, setTotalMaintenanceCost] = useState(0);
    const apiBaseUrl = useContext(ApiBaseUrlContext);

    const [activeSection, setActiveSection] = useState('details');
    const menuItems = [
      { key: 'details', label: t('machineDetails.sections.details') },
      { key: 'files', label: t('machineDetails.sections.files') },
      { key: 'faults', label: t('machineDetails.sections.faults') },
      { key: 'maintenance', label: t('machineDetails.sections.maintenance') },
    ];

    const getFileIcon = (ext) => {
      const extLower = ext.toLowerCase();
      if (['jpg', 'jpeg', 'png', 'gif', 'svg', 'svgz'].includes(extLower)) return <ImageIcon />;
      if (extLower === 'pdf') return <PdfIcon />;
      if (['doc', 'docx'].includes(extLower)) return <WordIcon />;
      if (['xls', 'xlsx'].includes(extLower)) return <ExcelIcon />;
      if (['ppt', 'pptx'].includes(extLower)) return <ExcelIcon />;
      if (['zip', 'rar'].includes(extLower)) return <ZipIcon />;
      if (['txt'].includes(extLower)) return <TextIcon />;
      if (['nc', 'dwg', 'cad', 'dxf', 'iges', 'step'].includes(extLower)) return <CadIcon />;
      return <GenericFileIcon />;
    }

    const faultToReportMap = closedServiceReports.reduce((map, report) => {
      if (report.faultID) {
        map[report.faultID] = report.servicereportid;
      }
      return map;
    }, {});

    const handleFaultNavigation = (fault) => {
      const linkedReportId = faultToReportMap[fault.id];
      if (fault.status === 'Closed' && linkedReportId) {
        navigate(`/service-reports/${linkedReportId}`);
      } else if (fault.status === 'Closed') {
        navigate(`/time-reports`);
      } else {
        navigate(`/fault-error`);
      }
    };
    
    

    const renderFaults = (faults) =>
        faults.map(fault => (
        
        <React.Fragment key={fault.id}>
            <tr className="table-list-2__hoverable-row"
                onClick={(e) => {
                  const currentRow = e.currentTarget;
                  if (window.innerWidth < 700) {
                    currentRow.classList.toggle('table-list-2__selected');
                  } else {
                    handleFaultNavigation(fault);
                  }
                }}                
            >
                <td className={`table-list-2__elastic-cell ${ fault.status === 'Closed' ? 'color-block-grey' : `color-block-${fault.priority?.toLowerCase()}`}`}>
                  <a
                    className="table-list-2__primary-btn table-list-2__show-on-hover"
                    href={
                      fault.status === 'Closed'
                        ? faultToReportMap[fault.id]
                          ? `/service-reports/${faultToReportMap[fault.id]}`
                          : `/time-reports`
                        : `/fault-error`
                    }
                    onClick={(e) => e.stopPropagation()}
                  >
                     {t(`faultButtons.${fault.status.toLowerCase()}`)}
                  </a>

                    {fault.description}
                </td>
                <td className="table-list-2__hide-mobile">
                    {fault.status}
                </td>
                <td className={`table-list-2__hide-mobile ${ fault.status === 'Closed' ? 'color-circle-grey' : `color-circle-${fault.priority?.toLowerCase()}`}`}>
                    {fault.priority}
                </td>
                <td className="table-list-2__hide-mobile">{new Date(fault.created).toLocaleString()}</td>
                <td className="table-list-2__hide-mobile">{fault.technician || '-'}</td>
            </tr>

            <tr className="table-list-2__mobile-data-row">
                <td colSpan="4">
                    <table className="table-list-2__mobile-data-table">
                        <tbody>
                            <tr><td>{t('machineDetails.fault.status')}</td><td>{fault.status}</td></tr>
                            <tr><td>{t('machineDetails.fault.severity')}</td><td>{fault.priority}</td></tr>
                            <tr><td>{t('machineDetails.fault.reported')}</td><td>{new Date(fault.created).toLocaleString()}</td></tr>
                            <tr><td>{t('machineDetails.fault.technician')}</td><td>{fault.technician || '-'}</td></tr>
                        </tbody>
                    </table>

                    <div className="table-list-2__mobile-data-options">
                    <button
                      type="button"
                      className="button--blue"
                      onClick={() => handleFaultNavigation(fault)}
                    >
                      {fault.status === 'New' ? 'Start' : fault.status === 'Open' ? 'Open' : 'View'}
                    </button>
                    </div>
                </td>
            </tr>
        </React.Fragment>
    ));



    const formatCost = (amount) => {
        const value = (typeof amount === 'number' && !isNaN(amount)) ? amount.toFixed(2) : '0.00';
      
        return currencyPosition === 'left'
          ? `${currencySymbol} ${value}`
          : `${value} ${currencySymbol}`;
      };


    useEffect(() => {
        const fetchSettings = async () => {
          try {
            const response = await axios.get(`${apiBaseUrl}/mnt/api/settings`);
            const settings = response.data;
      
            setCurrencySymbol(settings.currencySymbol || 'kr');
            setCurrencyPosition(settings.currencyPosition || 'right');
          } catch (error) {
            console.error('Error fetching settings:', error);
          }
        };
      
        fetchSettings();
    }, [apiBaseUrl]);

    useEffect(() => {
        if (!machineid) return; // Avoid running if machineid is not available

        const fetchMachineData = async () => {
            try {
                // Fetch the machine details
                const machineResponse = await axios.get(`/mnt/api/machines/${machineid}`);
                const machineData = machineResponse.data;

                // Fetch the cost details
                const costResponse = await axios.get(`/mnt/api/machines/cost/${machineid}`);
                const costData = costResponse.data;

                const enrichedMachine = {
                    ...machineData,
                    image_path: machineData.image_path || machineHolder,
                    machineTotalCost: costData.machineTotalCost,
                    serviceReportTimeCost: costData.serviceReportTimeCost || 0,
                    serviceReportMaterialCost: costData.serviceReportMaterialCost || 0,
                    serviceReportTotalCost: costData.serviceReportTotalCost || 0,
                    maintenanceTimeCost: costData.maintenanceTimeCost || 0,
                    maintenanceMaterialCost: costData.maintenanceMaterialCost || 0,
                    maintenanceTotalCost: costData.maintenanceTotalCost || 0
                };

                setMachine(enrichedMachine);
                setSelectedMachineCost(costData); 
            } catch (error) {
                console.error("Error fetching machine data:", error);
                setMachine(null); // or some fallback state
            }
        };

        fetchMachineData();
    }, [machineid]);

    useEffect(() => {
        if (machineid) {
          axios.get(`/mnt/api/machines/${machineid}`)
            .then(response => setMachine(response.data))
            .catch(error => console.error('Error fetching machine details:', error));
      
          // Fetch reseller info
          axios.get(`/mnt/api/machines/${machineid}/reseller`)
            .then(res => {
              if (res.data) setReseller(res.data);
            })
            .catch(() => {});
      
          // Fetch external techs
          axios.get(`/mnt/api/machines/${machineid}/external-techs`)
            .then(res => setExternalTechs(res.data))
            .catch(() => {});
        }
    }, [machineid]);

    useEffect(() => {
        if (machine) {
            axios.get(`/mnt/api/service-reports/closed/byMachine/${encodeURIComponent(machine.machine)}`)
                .then(response => setClosedServiceReports(response.data))
                .catch(error => console.error('Error fetching closed service reports:', error));

            axios.get(`/mnt/api/service-reports/active/byMachine/${encodeURIComponent(machine.machine)}`)
                .then(response => setActiveServiceReports(response.data))
                .catch(error => console.error('Error fetching active service reports:', error));

            axios.get(`/mnt/api/fault-errors/byMachine/${encodeURIComponent(machine.machine)}`)
                .then(response => setFaultErrors(response.data))
                .catch(error => console.error('Error fetching fault errors:', error));

            axios.get(`/mnt/api/maintenance/${machineid}`)
            .then((response) => {
                const openMaintenances = response.data.filter(item => item.closed === null);

                // Initial structure for categorization
                const categorized = {
                    daily: [], weekly: [], monthly: [], annually: [],
                    upcoming: [], new: [], open: [], overdue: []
                };

                openMaintenances.forEach((schedule) => {
                    const type = schedule.maintenance_type.toLowerCase();
                    if (categorized[type]) {
                        categorized[type].push(schedule);
                    }

                    // Categorize by status
                    if (schedule.status === "Upcoming") {
                        categorized.upcoming.push(schedule);
                    } else if (schedule.status === "New") {
                        categorized.new.push(schedule);
                    } else if (schedule.status === "Open") {
                        categorized.open.push(schedule);
                    } else if (schedule.status === "Overdue") {
                        categorized.overdue.push(schedule);
                    }
                });

                setMachineMaintenances(categorized);
            })
            .catch((error) => {
                console.error('Error fetching maintenance schedules:', error);
            });
        }
    }, [machine]);

    if (!machine) return <p></p>;

    

    return (
        <div className="content">

            <div className="top-menu">
                <div className="top-menu__divider"></div>
                <div className="top-menu__icon-button top-menu__back-button-arrow" onClick={() => navigate('/machines')} style={{ cursor: 'pointer' }}>
                    <BackIcon />
                </div>
            </div>

            <div className="mobile-dropdown-menu">
                <div className="mobile-dropdown-menu__title">{t('machineDetails.sectionTitle')}</div>
                <select
                    className="mobile-dropdown-menu__select"
                    id="menu-select"
                    value={activeSection}
                    onChange={(e) => setActiveSection(e.target.value)}
                >
                    {menuItems.map(item => (
                        <option key={item.key} value={item.key}>
                            {item.label}
                        </option>
                    ))}
                </select>
            </div>

            <div className="machine-profile__layout">

                <div className="machine-profile__profile-image">
                    <img 
                        src={machine.image_path || machineHolder} 
                        alt={machine.machine} 
                        onError={(e) => e.target.src = machineHolder} 
                    />
                </div>

                <div>

                    <div className="machine-profile__title-container">
                        <div className="machine-profile__profile-image-mobile">
                        <img 
                            src={machine.image_path || machineHolder} 
                            alt={machine.machine} 
                            onError={(e) => e.target.src = machineHolder} 
                        />
                        </div>
                        <div className="content__main-title">{machine.machine}</div>
                    </div>

                    <div className="machine-profile__menu">
                        <div className="machine-profile__menu-sections">{t('machineDetails.sectionTitle')}</div>
                        <nav>
                            <ul className="menu">
                                {menuItems.map(item => (
                                <li key={item.key}>
                                    <a
                                        href="#"
                                        className={activeSection === item.key ? 'active' : ''}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setActiveSection(item.key);
                                        }}
                                    >
                                        {item.label}
                                    </a>
                                </li>
                                ))}
                            </ul>
                        </nav>
                    </div>

                    <div className={`machine-profile__page details ${activeSection === 'details' ? '' : 'hidden'}`}>

                        <table className="machine-profile__databox">
                            <tbody>
                                <tr><td>{t("machineDetails.group")}</td><td>{machine.dncmaxgroupname}</td></tr>
                                <tr><td>{t("machineDetails.category")}</td><td>{machine.category}</td></tr>
                                <tr><td>{t("machineDetails.serialNumber")}</td><td>{machine.serial_number}</td></tr>
                                <tr><td>{t("machineDetails.control")}</td><td>{machine.system}</td></tr>
                                <tr><td>{t("machineList.priority")}</td><td className="priority-cell">
                                                    <span className={`table-list__dot-color table-list__dot-color-${machine.priority.toLowerCase()}`}></span>
                                                    {machine.priority}
                                                </td></tr>
                                <tr><td>{t("machineDetails.notes")}</td><td>{machine.notes}</td></tr>
                                {machine.placement && (
                                  <tr>
                                    <td>{t("machineDetails.placement")}</td>
                                    <td>{machine.placement}</td>
                                  </tr>
                                )}
                            </tbody>
                        </table>

                        <div className="machine-profile__section-header">{t("machineDetails.reseller.sectionTitle")}</div>
                        {reseller ? (

                            <>

                            <table className="machine-profile__databox">
                                <tbody>
                                    <tr><td>{t("machineDetails.reseller.companyName")}</td><td>{reseller.company_name}</td></tr>
                                    <tr><td>{t("machineDetails.reseller.address")}</td><td>{reseller.address}</td></tr>
                                    <tr><td>{t("machineDetails.reseller.contactName")}</td><td>{reseller.contact_name}</td></tr>
                                    <tr><td>{t("machineDetails.reseller.phone")}</td><td>{reseller.contact_phone}</td></tr>
                                    <tr><td>{t("machineDetails.reseller.email")}</td><td>{reseller.contact_email}</td></tr>
                                    <tr><td>{t("machineDetails.reseller.dateOfPurchase")}</td><td>{reseller.date_of_purchase 
                                    ? new Date(reseller.date_of_purchase).toISOString().slice(0, 10) 
                                    : ""}</td></tr>
                                </tbody>
                            </table>

                            </>
 
                        ) : (
                           <div class="machine-profile__nodata-box">{t("machineDetails.reseller.noneAvailable")}</div>
                        )}

                        <div className="machine-profile__section-header">{t("machineDetails.externalTechnicians.sectionTitle")}</div>
{/* External Technicians Section */}
{(Array.isArray(externalTechs) ? externalTechs : []).length > 0 ? (
  <table className="table-list-2">
    <thead>
      <tr>
        <th>{t('machineDetails.externalTechnicians.name')}</th>
        <th className="table-list-2__hide-mobile">{t('machineDetails.externalTechnicians.company')}</th>
        <th className="table-list-2__hide-mobile">{t('machineDetails.externalTechnicians.phone')}</th>
        <th className="table-list-2__hide-mobile">{t('machineDetails.externalTechnicians.email')}</th>
      </tr>
    </thead>
    <tbody>
      {(Array.isArray(externalTechs) ? externalTechs : []).map((tech) => (
        <React.Fragment key={tech.userid}>
          <tr className="table-list-2__hoverable-row">
            <td className="table-list-2__elastic-cell">
              {tech.userfirstname} {tech.userlastname}
            </td>
            <td className="table-list-2__hide-mobile">{tech.company}</td>
            <td className="table-list-2__hide-mobile">{tech.usermobilenumber}</td>
            <td className="table-list-2__hide-mobile">{tech.useremail}</td>
          </tr>
          <tr className="table-list-2__mobile-data-row">
            <td colSpan="4">
              <table className="table-list-2__mobile-data-table">
                <tbody>
                  <tr>
                    <td>Name</td>
                    <td>{tech.userfirstname} {tech.userlastname}</td>
                  </tr>
                  <tr>
                    <td>Company</td>
                    <td>{tech.company}</td>
                  </tr>
                  <tr>
                    <td>Phone</td>
                    <td>{tech.usermobilenumber}</td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>{tech.useremail}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </React.Fragment>
      ))}
    </tbody>
  </table>
) : (
  <div className="machine-profile__nodata-box">
    {t("machineDetails.externalTechnicians.noneAssigned")}
  </div>
)}


                        <div className="machine-profile__section-header">
                        {t("costBreakdown.title")} ({t("costBreakdown.maintenanceCost")})
                        </div>
                        <table className="machine-profile__databox">
                        <thead>
                            <tr>
                            <td>{t("costBreakdown.serviceReportTitle")}</td><td></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            <td>{t("costBreakdown.serviceReportTimeCost")}</td>
                            <td>{formatCost(selectedMachineCost?.serviceReportTimeCost)}</td>
                            </tr>
                            <tr>
                            <td>{t("costBreakdown.serviceReportMaterialCost")}</td>
                            <td>{formatCost(selectedMachineCost?.serviceReportMaterialCost)}</td>
                            </tr>
                            <tr>
                            <td>{t("costBreakdown.serviceReportTotalCost")}</td>
                            <td>{formatCost(selectedMachineCost?.serviceReportTotalCost)}</td>
                            </tr>
                        </tbody>
                        <thead>
                            <tr>
                            <td>{t("costBreakdown.maintenanceTitle")}</td><td></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            <td>{t("costBreakdown.maintenanceTimeCost")}</td>
                            <td>{formatCost(selectedMachineCost?.maintenanceTimeCost)}</td>
                            </tr>
                            <tr>
                            <td>{t("costBreakdown.maintenanceMaterialCost")}</td>
                            <td>{formatCost(selectedMachineCost?.maintenanceMaterialCost)}</td>
                            </tr>
                            <tr>
                            <td>{t("costBreakdown.maintenanceTotalCost")}</td>
                            <td>{formatCost(selectedMachineCost?.maintenanceTotalCost)}</td>
                            </tr>
                        </tbody>
                        <thead>
                            <tr>
                            <td>{t("costBreakdown.totalMachineCost")}</td>
                            <td>{formatCost(selectedMachineCost?.machineTotalCost)}</td>
                            </tr>
                        </thead>
                        </table>


                    </div>

                    <div className={`machine-profile__page faults ${activeSection === 'faults' ? '' : 'hidden'}`}>
                        
                        {Array.isArray(faultErrors) && faultErrors.length > 0 ? (
                            <>
                            
                            <table className="table-list-2 synced-table">
                                <thead>
                                    <tr>
                                        <th>{t('machineDetails.fault.description')}</th>
                                        <th className="table-list-2__hide-mobile">{t('machineDetails.fault.status')}</th>
                                        <th className="table-list-2__hide-mobile">{t('machineDetails.fault.severity')}</th>
                                        <th className="table-list-2__hide-mobile">{t('machineDetails.fault.reported')}</th>
                                        <th className="table-list-2__hide-mobile">{t('machineDetails.fault.technician')}</th>
                                    </tr>
                                </thead>    
                                <tbody>

                                    {renderFaults(faultErrors.filter(fault => fault.status === 'New'))}

                                    {renderFaults(faultErrors.filter(fault => fault.status === 'Open'))}

                                    {renderFaults(faultErrors.filter(fault => fault.status === 'Closed'))}

                                </tbody>
                            </table>

                            </>
                        ) : (
                            <div class="machine-profile__nodata-box">{t('machineDetails.faultDataUnavailable')}</div>
                        )}

                    </div>



                    <div className={`machine-profile__page maintenance ${activeSection === 'files' ? '' : 'hidden'}`}>

                        {Array.isArray(machine.file_paths) && machine.file_paths.length > 0 ? (

                            <table class="table-list-2">
                                <thead>
                                    <tr>
                                        <th>{t('machineDetails.file.filename')}</th>
                                        <th class="table-list-2__hide-mobile">{t('machineDetails.file.category')}</th>
                                        <th class="table-list-2__hide-mobile">{t('machineDetails.file.type')}</th>
                                        <th class="table-list-2__hide-mobile">{t('machineDetails.file.size')}</th>
                                    </tr>
                                </thead>    
                                <tbody>
                                  {machine.file_paths
                                    .slice() // clone array to avoid mutating original state
                                    .sort((a, b) => {
                                      const categoryA = (a.category || '').toUpperCase();
                                      const categoryB = (b.category || '').toUpperCase();
                                      return categoryA.localeCompare(categoryB);
                                    })
                                    .map((file, index) => {
                                      const fileExtension = file.path.split('.').pop().toUpperCase();
                                      const fileSize = file.size
                                        ? `${(file.size / (1024 * 1024)).toFixed(2)} MB`
                                        : 'Unknown size';

                                      return (
                                        <React.Fragment key={index}>
                                          <tr className="table-list-2__hoverable-row">
                                          <td className="table-list-2__elastic-cell">
                                              <div className="table-list-2__cell-icon">{getFileIcon(fileExtension)}</div>
                                              <a
                                                  href={`${apiBaseUrl}/mnt/api/uploads/machine/${file.path.replace('/uploads/machines/', '')}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  style={{ textDecoration: 'none', color: 'inherit' }}
                                                >
                                                  {file.title}
                                                </a>
                                            </td>
                                            <td className="table-list-2__hide-mobile">{file.category || 'Unknown'}</td>
                                            <td className="table-list-2__hide-mobile">{fileExtension}</td>
                                            <td className="table-list-2__hide-mobile">{fileSize}</td>
                                          </tr>
                                          <tr className="table-list-2__mobile-data-row">
                                            <td colSpan="4">
                                              <table className="table-list-2__mobile-data-table">
                                                <tbody>
                                                  <tr><td>{t('machineDetails.file.category')}</td><td>{file.category || 'Unknown'}</td></tr>
                                                  <tr><td>{t('machineDetails.file.type')}</td><td>{fileExtension}</td></tr>
                                                  <tr><td>{t('machineDetails.file.size')}</td><td>{fileSize}</td></tr>
                                                </tbody>
                                              </table>
                                            </td>
                                          </tr>
                                        </React.Fragment>
                                      );
                                    })}
                                </tbody>
                            </table>
                        ) : (
                            <div className="machine-profile__nodata-box">{t('machineDetails.filesUnavailable')}</div>
                        )}

                    </div>

                    <div className={`machine-profile__page maintenance ${activeSection === 'maintenance' ? '' : 'hidden'}`}>
                                    

                     {(() => {
                      const hasAnyMaintenance = [
                        'daily',
                        'weekly',
                        'monthly',
                        'annually',
                        'upcoming',
                        'new',
                        'open',
                        'overdue',
                      ].some(
                        (key) =>
                          Array.isArray(machineMaintenances[key]) &&
                          machineMaintenances[key].length > 0
                      );

                      if (!hasAnyMaintenance) {
                        return (
                          <div className="machine-profile__nodata-box">
                            {t('machineDetails.noMaintenanceScheduled')}
                          </div>
                        );
                      }

                      return (
                        <>

                            {/* Maintenance by Frequency */}

                          <div className="machine-profile__section-header">
                            {t('machineDetails.maintenanceByFrequency')}
                          </div>

                          <table className="table-list-2 synced-table">
                            <thead>
                              <tr>
                                <th>{t('machineDetails.description')}</th>
                                <th className="">{t('machineDetails.frequencyOrStatus')}</th>
                                <th className="table-list-2__hide-mobile">{t('machineDetails.nextDue')}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* Frequency group */}
                              {['daily', 'weekly', 'monthly', 'annually'].map((type) =>
                                machineMaintenances[type]?.map((schedule) => (
                                  <React.Fragment key={schedule.scheduleid}>
                                    <tr
                                      className="table-list-2__hoverable-row"
                                      onClick={(e) => {
                                        const currentRow = e.currentTarget;
                                        if (window.innerWidth < 700) {
                                          currentRow.classList.toggle('table-list-2__selected');
                                        } else {
                                          navigate(`/maintenance-schedule?scheduleid=${schedule.scheduleid}`);
                                        }
                                      }}
                                    >
                                      <td className="table-list-2__elastic-cell">
                                        {/*
                                        <a
                                          className="table-list-2__primary-btn table-list-2__show-on-hover"
                                          href={`/mnt/machine/${schedule.machineid}`}
                                        >
                                          {t('machineDetails.view')}
                                        </a>
                                        */}
                                        {schedule.descHeader}
                                      </td>
                                      <td className="">{type}</td>
                                      <td className="table-list-2__hide-mobile">
                                        {new Date(schedule.next_maintenance_date * 1000).toLocaleString()}
                                      </td>
                                    </tr>
                                    <tr className="table-list-2__mobile-data-row">
                                      <td colSpan="3">
                                        <table className="table-list-2__mobile-data-table">
                                          <tbody>
                                            <tr>
                                              <td>{t('machineDetails.nextDue')}</td>
                                              <td>{new Date(schedule.next_maintenance_date * 1000).toLocaleString()}</td>
                                            </tr>
                                            <tr>
                                              <td>{t('machineDetails.frequency')}</td>
                                              <td>{type}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <div className="table-list-2__mobile-data-options">
                                          <button
                                            type="button"
                                            className="button--blue"
                                            onClick={() =>
                                              navigate(`/maintenance-schedule?scheduleid=${schedule.scheduleid}`)
                                            }
                                          >
                                            {t('machineDetails.view')}
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                ))
                              )}

                              <tr className="table-list-2__section-header">
                                <td colSpan="3">{t('machineDetails.maintenanceByStatus')}</td>
                              </tr>

                              {/* Status group */}
                              {['upcoming', 'new', 'open', 'overdue'].map((status) =>
                                machineMaintenances[status]?.map((schedule) => (
                                  <React.Fragment key={schedule.scheduleid}>
                                    <tr
                                      className="table-list-2__hoverable-row"
                                      onClick={(e) => {
                                        const currentRow = e.currentTarget;
                                        if (window.innerWidth < 700) {
                                          currentRow.classList.toggle('table-list-2__selected');
                                        } else {
                                          navigate(`/maintenance-schedule?scheduleid=${schedule.scheduleid}`);
                                        }
                                      }}
                                    >
                                      <td
                                        className={`table-list-2__elastic-cell ${
                                          status === 'open'
                                            ? 'color-block-blue'
                                            : status === 'overdue'
                                            ? 'color-block-red'
                                            : 'color-block-grey'
                                        }`}
                                      >
                                        {/*
                                        <a
                                          className="table-list-2__primary-btn table-list-2__show-on-hover"
                                          href={`/mnt/machine/${schedule.machineid}`}
                                        >
                                          {t('machineDetails.view')}
                                        </a>
                                        */}
                                        {schedule.descHeader}
                                      </td>
                                      <td className="">{t(`machineDetails.${status}`)}</td>
                                      <td className="table-list-2__hide-mobile">
                                        {new Date(schedule.next_maintenance_date * 1000).toLocaleString()}
                                      </td>
                                    </tr>
                                    <tr className="table-list-2__mobile-data-row">
                                      <td colSpan="3">
                                        <table className="table-list-2__mobile-data-table">
                                          <tbody>
                                            <tr>
                                              <td>{t('machineDetails.nextDue')}</td>
                                              <td>{new Date(schedule.next_maintenance_date * 1000).toLocaleString()}</td>
                                            </tr>
                                            <tr>
                                              <td>{t('machineDetails.status')}</td>
                                              <td>{t(`machineDetails.${status}`)}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <div className="table-list-2__mobile-data-options">
                                          <button
                                            type="button"
                                            className="button--blue"
                                            onClick={() =>
                                              navigate(`/maintenance-schedule?scheduleid=${schedule.scheduleid}`)
                                            }
                                          >
                                            {t('machineDetails.view')}
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                ))
                              )}
                            </tbody>
                          </table>
                        </>
                      );
                    })()}




                    </div>





                </div>
            </div>

        </div>
    );
};

export default MachineDetails;
